import React, { useMemo } from 'react';

import GeofenceEditorPanel from './GeofenceEditorPanel.jsx';
import { useSetModalTitle } from '../../../hooks/modal/useSetModalTitle';

interface GeofenceEditorPanelWrapperProps {
  geofence: any;
  onSave: any;
  onDelete: any;
};
export const GeofenceEditorPanelWrapper: React.FC<GeofenceEditorPanelWrapperProps> = 
  ({ geofence, onSave, onDelete }: GeofenceEditorPanelWrapperProps) => {
    
  const title = useMemo(() => {
    if (geofence && geofence.persisted) {
      return 'Edit Geofence';
    } else {
      return 'New Geofence';
    }
  }, [geofence]);


  useSetModalTitle(title);

  return <GeofenceEditorPanel 
    geofence={geofence} 
    onSave={onSave} 
    onDelete={onDelete} />;
};